import type { Instance } from './api';
import { t } from './lingua';

/**
 * Le copie di prova negli elenchi.
 *
 * Una copia si legge come «la prova di *acme*», non come un'istanza a sé:
 * negli elenchi sta subito sotto la sua produzione. Senza, le copie finivano
 * in cima (sono le più giovani) e si riconoscevano solo dal nome.
 */

/**
 * L'elenco con ogni copia subito dopo la sua produzione. L'ordine delle
 * produzioni resta quello ricevuto; una copia la cui produzione non è
 * nell'elenco — cancellata, o su un altro server — resta dove stava.
 */
export function conLeCopieSotto(istanze: Instance[]): Instance[] {
  const presenti = new Set(istanze.map((i) => i.id));
  const figlie = (id: string) => istanze.filter((i) => i.staging?.fromId === id);
  return istanze
    .filter((i) => !i.staging?.fromId || !presenti.has(i.staging.fromId))
    .flatMap((i) => [i, ...figlie(i.id)]);
}

/**
 * «3 istanze · 1 copia»: le copie non si contano fra le istanze. Corto, per
 * una colonna che si chiama già «Istanze»: «3 · 1 copia».
 */
export function contaIstanze(istanze: Instance[], corto = false): string {
  const copie = istanze.filter((i) => i.staging).length;
  const vere = istanze.length - copie;
  const prima = corto ? String(vere) : vere === 0 ? t('Nessuna istanza') : vere === 1 ? t('1 istanza') : t('{n} istanze', { n: vere });
  if (copie === 0) return prima;
  return `${prima} · ${copie === 1 ? t('1 copia') : t('{n} copie', { n: copie })}`;
}

/** Quanto resta a una copia, detto corto: sta in un chip. */
export function restaAllaCopia(giorni: number): string {
  if (giorni < 0) return t('scaduta');
  if (giorni === 0) return t('ultimo giorno');
  return giorni === 1 ? t('1 giorno') : t('{n} giorni', { n: giorni });
}
